module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_prf_r1"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_prf_r1#h1"
    }
  }, [_vm._v("MCMILLAN|DOOLITTLE: A BRIEF HISTORY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_prf_r1#h2"
    }
  }, [_vm._v("MCMILLAN|DOOLITTLE’S POINT OF VIEW")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_p01_r1"
    }
  }, [_vm._v("PART I - The Theory")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c01_r1"
    }
  }, [_vm._v("CHAPTER ONE - EST: A COMPASS TO AVOID RETAIL’S BLACK HOLE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c01_r1#h1"
    }
  }, [_vm._v("EST DEFINED")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c01_r1#h2"
    }
  }, [_vm._v("EST IS NOT A MARKETING TOOL")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c01_r1#h3"
    }
  }, [_vm._v("THE INTRODUCTION OF EST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c01_r1#h4"
    }
  }, [_vm._v("DOES EST CHANGE? ABSOLUTELY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c01_r1#h5"
    }
  }, [_vm._v("PUTTING EST TO WORK")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c01_r1#h6"
    }
  }, [_vm._v("THE PROOF IS IN THE RESULTS")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWO - CUSTOMERS ARE #1 Now It’s Time for Retailers to Start Treating  ...")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c02_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE MYTHS OF CUSTOMER SERVICE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II - The Practice")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE - CHEAP-EST: WINNING WITH PRICE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHEAP-EST DEFINED")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR - BIG-EST: WINNING WITH DOMINANT ASSORTMENTS")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ARE CATEGORY KILLERS STILL KILLERS?")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE - HOT-EST: WINNING WITH FASHION")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX - EASY-EST: WINNING WITH SOLUTION-ORIENTED SERVICE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN - QUICK-EST: WINNING WITH FAST SERVICE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FUTURE FOR QUICK-EST LOOKS BRIGHT")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT - PUTTING EST TO WORK")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c08_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GREENS FEES, PAR, AND EST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c08_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPLYING EST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c08_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EST IN THE REAL WORLD")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c08_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EST IN ACTION: BEST BUY AND COACH")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III - The Future")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE - EST ISN’T FOREVER Retail Is Tougher Than Ever")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONSOLIDATION")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMPRESSED LIFE CYCLE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE’S A CROWD")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c09_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FALLING OUT OF EST")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c09_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARKET SQUEEZE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN - DEVELOPING TOMORROW’S HOT IDEAS")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE HOT ZONE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOME-HAPPY BOOMERS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO APPROACHES TO GENERATION Y: GET THE PARENTS, GET THE KIDS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INCREASING ETHNIC DIVERSITY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAVES AND HAVE-NOTS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LOOKING INSIDE FOR HOT IDEAS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GO WHERE THE CUSTOMERS ARE")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c10_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WINNING RETAILERS ARE IN MOTION")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN - PUTTING THE CUSTOMER IN CONTROL")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c11_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RETAILER EFFICIENCY VERSUS CUSTOMER EFFICIENCY")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c11_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FIVE CS OF PUTTING THE CUSTOMER IN CONTROL")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c11_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CUSTOMERS IN CONTROL: GUIDELINES TO LIVE BY")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE - A GLANCE AT THE FUTURE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_c12_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FUTURE TRENDS")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_nts_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/ande_9781118039977_oeb_in1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-590135a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ande_9781118039977_oeb_toc_r1.vue
// module id = 57
// module chunks = 0